import { useZero } from "@rocicorp/zero/react";
import { sharedMutators } from "../../../../shared/mutators";
import { Button } from "../../Button";
import { ConfirmModal } from "../../ConfirmModal";
import { Modal } from "../../Modal";
import { Text } from "../../Text";
import { CopyableValue } from "../CopyableValue";
import { ModalContent, ModalFooter } from "../shared";

export function ScimTokenModal({
  token,
  onClose,
}: {
  token: string | null;
  onClose: () => void;
}) {
  if (!token) return null;
  return (
    <Modal open onClose={onClose}>
      <ModalContent>
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <Text variant="text-regular-md">SCIM token created</Text>
          <Text variant="text-regular" color="var(--text-secondary)">
            Copy this token now. You won’t be able to see it again.
          </Text>
        </div>
        <CopyableValue value={token}>
          <Text
            variant="text-regular"
            color="var(--text-secondary)"
            style={{ flex: 1 }}
          >
            {token}
          </Text>
        </CopyableValue>
        <ModalFooter>
          <Button size="l" onClick={onClose}>
            Done
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export function RevokeSessionsModal({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const z = useZero();
  return (
    <ConfirmModal
      open={open}
      onClose={onClose}
      onConfirm={() => {
        z.mutate(sharedMutators.revokeAllSessions({}));
        onClose();
      }}
      title="Revoke all sessions"
      description="Everyone else will be signed out and have to sign in again. You’ll stay signed in."
      confirmLabel="Revoke all"
      destructive
    />
  );
}
